// extracted by mini-css-extract-plugin
module.exports = {"modalButtons":"Modal_modalButtons__wmiRQ","buttons":"Modal_buttons__2nax-","modal":"Modal_modal__35xss","close":"Modal_close__10OQt"};